// Campus photo for /colleges/university-of-delaware: CC BY-SA 3.0, by Cargoudel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUDel_Memorial_and_Magnolia_Circle.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-delaware/; credited under the photo.
const photo = {
    "slug": "university-of-delaware",
    "alt": "Memorial Hall seen across the fountain at Magnolia Circle on the University of Delaware campus in Newark, Delaware",
    "src": "/colleges/university-of-delaware/campus-1600.webp",
    "srcSmall": "/colleges/university-of-delaware/campus-800.webp",
    "srcMid": "/colleges/university-of-delaware/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-delaware/og.jpg",
    "title": "UDel Memorial and Magnolia Circle",
    "author": "Cargoudel",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUDel_Memorial_and_Magnolia_Circle.JPG",
    "read": "2026-10-01"
};

export default photo;
